import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from '@ntconsult/aluma-react';
import { fileService } from '../services/fileService';

interface UpdateFilePayload {
  name?: string;
  description?: string;
  tags?: string[];
}

export function useUpdateFile(fileId: string) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('files');

  return useMutation({
    mutationFn: (data: UpdateFilePayload) => fileService.updateFile(fileId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['file', fileId] });
      queryClient.invalidateQueries({ queryKey: ['files'] });
    },
    onError: () => {
      toast.danger({ title: t('toasts.updateError') });
    },
  });
}
